"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANGE_INDICATOR_CATEGORY_KEY = 'overview';
exports.CHANGE_INDICATOR_COMPONENT_KEY = 'changeIndicator';